(function () {
    'use strict';

    angular
        .module('services')
        .service('NewsService', NewsService);

    NewsService.$inject = ['$http', 'API_BASE'];

    function NewsService($http, API_BASE) {
        var service = this;

        service.storeNews = storeNews;
        service.list = list;
        service.getNews = getNews;
        service.updateNews = updateNews;
        service.deleteNews = deleteNews;

        // /* STORE A NEW */
        function storeNews(data) {
            return $http.post(API_BASE + '/news/store', data)
                .then(function (response) {
                    return response.data;
                });
        }

        function list(query) {
            return $http.get(API_BASE + '/news/list', {
                params: query
            });
        }

        function getNews(id) {
            return $http.get(API_BASE + '/news/' + id);
        }

        function updateNews(id, data) {
            return $http.post(API_BASE + '/news/update/' + id, data)
                .then(function (response) {
                    return response.data;
                });
        }

        function deleteNews(id) {
            return $http.get(API_BASE + '/news/delete/' + id)
                .then(function (response) {
                    return response.data;
                });
        }

    }
})();